import React, { useState, useRef, useEffect } from 'react';
import './XMultiSelect.css';

const XMultiSelect = ({
    options = [],
    label,
    labelStyle = {},
    placeholder = 'Select Teams',
    selectedValues = [],
    onChange,
    isForm
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOptionToggle = (value) => {
        const newValues = selectedValues.includes(value)
            ? selectedValues.filter((v) => v !== value)
            : [...selectedValues, value];

        onChange(newValues);
    };

    const removeSelected = (value, e) => {
        e.stopPropagation();
        onChange(selectedValues.filter(v => v !== value));
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={`xmulti-select-container ${isForm ? 'form-width' : ''}`} ref={dropdownRef}>
            {label && (
                <label className="xmulti-label" style={labelStyle}>{label}</label>
            )}
            <div className={`xmulti-control ${isOpen ? 'active' : ''}`} onClick={toggleDropdown}>
                <div className="xmulti-value-container">
                    {selectedValues.length === 0 ? (
                        <span className="xmulti-placeholder">{placeholder}</span>
                    ) : (
                        <div className="xmulti-selected-values">
                            {options
                                .filter(option => selectedValues.includes(option.value))
                                .map(option => (
                                    <div key={option.value} className="xmulti-tag">
                                        <span className="xmulti-tag-text">{option.text}</span>
                                        <button 
                                            className="xmulti-tag-remove"
                                            onClick={(e) => removeSelected(option.value, e)}
                                            aria-label={`Remove ${option.text}`}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
                <div className="xmulti-indicators">
                    {selectedValues.length > 0 && (
                        <div className="xmulti-clear-indicator" 
                             onClick={(e) => { e.stopPropagation(); onChange([]); }}
                             title="Clear all">
                            ⨯
                        </div>
                    )}
                    <div className={`xmulti-dropdown-indicator ${isOpen ? 'open' : ''}`}>
                        ▼
                    </div>
                </div>
            </div>

            {isOpen && (
                <div className="xmulti-menu">
                    <div className="xmulti-menu-list">
                        {options.length === 0 ? (
                            <div className="xmulti-no-options">No options available</div>
                        ) : (
                            options.map((option) => (
                                <div 
                                    key={option.value} 
                                    className={`xmulti-option ${selectedValues.includes(option.value) ? 'selected' : ''}`}
                                    onClick={() => handleOptionToggle(option.value)}
                                >
                                    <div className="xmulti-checkbox" onClick={(e) => e.stopPropagation()}>
                                        <input
                                            type="checkbox"
                                            checked={selectedValues.includes(option.value)}
                                            onChange={() => handleOptionToggle(option.value)}
                                            id={`option-${option.value}`}
                                        />
                                        <label htmlFor={`option-${option.value}`} className="xmulti-checkbox-label"></label>
                                    </div>
                                    <div className="xmulti-option-label">{option.text}</div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default XMultiSelect;